import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getPlantList() {
  return axiosService({ method: 'GET', apiPath: API.PLANT_DATA })
}
